
import reducer from 'app/shared/pageSystem/reducer';
export default reducer;

export {PageStatus} from 'app/shared/pageSystem/state';
export * from 'app/shared/pageSystem/selectors';
export {initializeRouting} from 'app/shared/pageSystem/routing';